'use strict';
import KeyMirror from 'keymirror';

module.exports = {
  ActionTypes: KeyMirror({
    ERROR_HANDLED: null
  }),
  ErrorCodes: KeyMirror({
    FMS_SUBMIT: null,
    FMS_SUBMIT_BANK_BSB: null,
    FMS_SUBMIT_ACCOUNT_BSB: null,
    FMS_SUBMIT_NON_TRIS: null,
    FMS_SUBMIT_TRIS: null,
    FMS_SUBMIT_INVALID_SESSION: null
  })
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/ErrorHandlerConstants.js